import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  MBox,
  MFlex,
  MHeading,
  MPageContainer,
  MPageLoader,
  MText,
} from '../../../../../components/Monetize';
import { useNavigateToErrorPage } from '../../../../ErrorPages/ErrorPage';

/**
 * This page handles the partial oauth flow callback for Docusign
 * The flow only includes the consent part of the flow, and not the code verification part
 *
 * https://www.docusign.com/blog/developers/oauth-jwt-granting-consent
 */
export const DocusignCallback = () => {
  const navigateToErrorPage = useNavigateToErrorPage();
  const [success, setSuccess] = useState(false);
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const error = searchParams.get('error');
  const errorMessage = searchParams.get('error_message');

  useEffect(() => {
    if (code) {
      window.opener?.postMessage({ status: 'success' }, window.location.origin);
      setSuccess(true);
    } else if (error) {
      navigateToErrorPage(
        `There was an error processing your request. ${errorMessage || ''}`,
      );
      window.opener?.postMessage(
        { status: 'error', error, errorMessage },
        window.location.origin,
      );
    } else {
      // this page was accessed without the relevant query parameters
      window.opener?.postMessage({ status: 'error' }, window.location.origin);
      navigateToErrorPage(`There was an error processing your request.`);
    }
  }, [code, error, errorMessage, navigateToErrorPage]);

  // This window should automatically close, but if it doesn't, show a success message
  if (success) {
    return (
      <MPageContainer>
        <MBox
          display="flex"
          alignItems="center"
          flexDirection="column"
          justifyContent="center"
          flex={1}
        >
          <MHeading fontSize="2xl" mb="1">
            Success
          </MHeading>
          <MText fontSize="lg">
            Your consent was successfully recorded. You can close this window.
          </MText>
        </MBox>
      </MPageContainer>
    );
  }

  // show loading state while processing
  return (
    <MFlex justify="center" grow={1}>
      <MPageLoader />
    </MFlex>
  );
};
